import IntroScreen from 'features/advance/screens/lightning/IntroPage/components/IntroScreen/IntroScreen';

export default function IntroPage() {
  return <IntroScreen />;
}
